import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { Job } from 'generated/apolloComponents'
import Button from '@/components/atoms/Button'

interface IProps {
  job: Job
}

const JobImmediateRedirect = ({ job }: IProps) => {
  const { t } = useTranslation('common')

  const continueToApplication = () => {
    if (!job.redirectTo) return

    window.location.assign(job.redirectTo)
  }

  return (
    <main className='bg-gray-bg min-h-screen'>
      <div className='container py-14 md:py-24'>
        <section className='bg-white rounded-lg px-6 py-10 md:px-16 md:py-14 max-w-3xl mx-auto text-center'>
          <p className='text-c20 leading-6 font-medium text-gray-500 mb-3'>
            {job.company.name}
          </p>
          <h1 className='text-c32 font-medium mb-6'>{job.position}</h1>
          <p className='text-lg text-gray-500 mb-8'>
            {t('external_application_interstitial')}
          </p>
          <Button
            type='primary'
            size='large'
            onClick={continueToApplication}
            data-cy='btn-continue-external-application'
          >
            {t('continue_to_application')}
          </Button>
        </section>
      </div>
    </main>
  )
}

export default JobImmediateRedirect
